import React from 'react';

export function Card({ children, variant = 'solid', interactive = false, glow = 'green', padding = 'var(--space-6)', style = {}, onClick, ...rest }) {
  const variants = {
    solid:      { background: 'var(--surface-card)',    border: '1px solid var(--border-subtle)', color: 'var(--text-body)' },
    sunken:     { background: 'var(--surface-sunken)',  border: '1px solid var(--border-subtle)', color: 'var(--text-body)' },
    dark:       { background: 'var(--surface-inverse)', border: '1px solid var(--border-on-dark)', color: 'var(--text-on-dark)' },
    glass:      { background: 'var(--glass-dark-bg)',   border: '1px solid var(--glass-dark-border)', color: 'var(--text-on-dark)', backdropFilter: 'blur(var(--glass-blur))', WebkitBackdropFilter: 'blur(var(--glass-blur))' },
    glassLight: { background: 'var(--glass-light-bg)',  border: '1px solid var(--glass-light-border)', color: 'var(--text-body)', backdropFilter: 'blur(var(--glass-blur))', WebkitBackdropFilter: 'blur(var(--glass-blur))' },
  };

  const base = {
    borderRadius: 'var(--radius-lg)', padding,
    boxShadow: 'var(--shadow-sm)',
    transition: 'transform var(--dur-med) var(--ease-out), box-shadow var(--dur-med) var(--ease-out)',
    cursor: interactive ? 'pointer' : 'default',
    ...variants[variant], ...style,
  };

  const glowShadow = glow === 'blue' ? 'var(--glow-blue)' : 'var(--glow-green)';

  return (
    <div style={base} onClick={onClick}
      onMouseEnter={(e) => { if (interactive) { e.currentTarget.style.transform = 'translateY(var(--lift))'; e.currentTarget.style.boxShadow = glowShadow; } }}
      onMouseLeave={(e) => { if (interactive) { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; } }}
      {...rest}>
      {children}
    </div>
  );
}
